import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoLabel,
    RaikoSectionContainer, RaikoToggleOutlined, showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import RaikoBaseDialogContentContainer
    from "../../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";
import React, {useEffect, useState} from "react";
import {ProductService} from "../../../serverService/productService/ProductService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function ProductEnabled({productId}) {


    const service = new ProductService();
    const loading = new LoadingHelper(useLoadingDispatcher())


    const [published, setPublished] = useState(false);
    const [publishStateLoading, setPublishStateLoading] = useState(false);

    useEffect(() => {
        if (typeof service !== 'undefined'){
            handleGetEnabledFromServer()
        }
    }, []);

    function handleGetEnabledFromServer() {
        loading.show()
        service.getProductEnabled(productId)
            .then(response=>{
                setPublished(response.enabled)
            }).catch(reason => {
                showServerErrorMessage(reason)
        }).finally(_=>{
            loading.hide()
        })
    }


    function handleChangePublishProductState() {
        setPublishStateLoading(true)
        service.updateProductPublishState(
            productId,
            published
        ).then(response=>{
            if (published)
                showSuccessMessage("انتشار محصول با موفقیت انجام شد.")
            else
                showWarningMessage("وضعیت انتشار به پیش نویس تغییر پیدا کرد.")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_=>{
            setPublishStateLoading(false)
        })

    }
    return(
        <>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"وضعیت انتشار"}
                    subTitle={"تغییر وضعیت انتشار برای مشاهده ی محصول توسط کاربران"}
                    hasHelperButton
                    helperTitle={"وضعیت انتشار"}
                    helperContent={
                        <RaikoBaseDialogContentContainer>
                            <RaikoLabel
                                text={"محصول در ابتدا به صورت پیش نویس قرار خواهد گرفت و فقط توسط ادمین در پنل مدیریت قابل مشاهده و ویرایش خواهد بود."}/>
                            <RaikoLabel
                                text={"برای مشاهده ی محصول توسط کاربران می بایست وضعیت انتشار را از روی پیش نویس به منتشر شده تغییر دهید."}/>
                            <RaikoLabel
                                text={"⚠️قبل از انتشار محصول حتما از صحت اطلاعات و تکمیل بودن همه ی قسمت ها اطمینان حاصل نمایید!"}/>
                        </RaikoBaseDialogContentContainer>
                    }
                    hasActionButton
                    actionButtonLoadingState={publishStateLoading}
                    actionButtonOnclick={handleChangePublishProductState}
                >
                    <RaikoGridOneColumn>
                        <RaikoToggleOutlined
                            checked={published}
                            setChecked={setPublished}
                            labelText={"منتشر شده /  پیش نویس"}
                        />
                    </RaikoGridOneColumn>

                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </>
    )
}